module.exports = __webpack_public_path__ + "static/media/p3_1.2f469384.png";